const drawThreadGroups = (container, data, onDrag, onClick) => {
  const threadGroups = container
    .selectAll("g.thread-group")
    .data(data, (d) => d.id);

  const threadGroupsEnter = threadGroups
    .enter()
    .append("g")
    .data(data, (d) => d.id)
    .attr("class", "thread-group")
    .attr("data-class", "thread")
    .attr("data-type", "thread")
    .attr("data-id", (d) => d.id)
    .attr("cursor", "grab")
    .call(onDrag);

  threadGroupsEnter
    .append("rect")
    .attr("class", "thread")
    .attr("data-id", (d) => d.id)
    .attr("x", -10)
    .attr("rx", (d) => d.size.width / 20 || 0)
    .attr("ry", (d) => d.size.height / 20 || 0)
    .on("click", (event, d) => {
      event.stopPropagation(); // Prevent event propagation
      onClick(d);
    });

  threadGroupsEnter
    .merge(threadGroups)
    .attr(
      "transform",
      (d) => `translate(${d.position.x || 0}, ${d.position.y || 0})`
    );

  threadGroupsEnter
    .merge(threadGroups)
    .select("rect")
    .attr("width", (d) => d.size.width)
    .attr("height", (d) => d.size.height);

  threadGroups.exit().remove();
};

export { drawThreadGroups };
